// GLSL assembly for the effects engine: every effect body is injected into
// this template, so adding a new effect = adding one body string.

const HEAD = `precision mediump float;
varying vec2 v_uv;
uniform sampler2D u_image;
uniform vec2 u_res;
uniform float u_time;
uniform float u_prog;
uniform float u_intensity;
uniform float u_speed;
uniform float u_amount;
uniform float u_opacity;
uniform float u_exposure;
uniform float u_highlights;
uniform float u_shadows;
uniform float u_temp;
uniform float u_tint;
uniform float u_fade;
uniform float u_sharp;
float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453123);}
float noise(vec2 p){vec2 i=floor(p);vec2 f=fract(p);f=f*f*(3.0-2.0*f);return mix(mix(hash(i),hash(i+vec2(1.0,0.0)),f.x),mix(hash(i+vec2(0.0,1.0)),hash(i+vec2(1.0,1.0)),f.x),f.y);}
vec3 S(vec2 uv){return texture2D(u_image, clamp(uv, vec2(0.002), vec2(0.998))).rgb;}
float lum(vec3 c){return dot(c, vec3(0.299,0.587,0.114));}
`;

const TAIL = `
vec3 adjustColor(vec3 c){
  c *= u_exposure;
  float l = lum(c);
  c += (1.0 - smoothstep(0.0, 0.5, l)) * u_shadows;
  c += smoothstep(0.5, 1.0, l) * u_highlights;
  c.r *= 1.0 + u_temp * 0.5;
  c.b *= 1.0 - u_temp * 0.5;
  c.r += u_tint * 0.25;
  c.b += u_tint * 0.25;
  c.g *= 1.0 - u_tint * 0.4;
  c = c * (1.0 - u_fade * 0.25) + vec3(u_fade * 0.06);
  return clamp(c, 0.0, 1.0);
}
void main(){
  vec2 uv = v_uv;
  vec3 base = S(uv);
  vec3 c = effect(uv);
  if (u_sharp > 0.001) {
    float o = 0.0015;
    vec3 bb = (S(uv + vec2(o, 0.0)) + S(uv - vec2(o, 0.0)) + S(uv + vec2(0.0, o)) + S(uv - vec2(0.0, o))) / 4.0;
    c += (c - bb) * u_sharp * 2.0;
    base += (base - bb) * u_sharp * 2.0;
  }
  base = adjustColor(clamp(base, 0.0, 1.0));
  c = adjustColor(clamp(c, 0.0, 1.0));
  float m = clamp(u_intensity * u_opacity, 0.0, 1.0);
  gl_FragColor = vec4(mix(base, c, m), 1.0);
}`;

export function buildFrag(body) {
    return HEAD + "\nvec3 effect(vec2 uv){\n  vec3 c = vec3(0.0);\n" + body + "\n  return c;\n}" + TAIL;
}
